export const DOCUMENT_GET_REQUEST = "DOCUMENT_GET_REQUEST";
export const DOCUMENT_GET_SUCCESS = "DOCUMENT_GET_SUCCESS";
export const DOCUMENT_GET_FAILURE = "DOCUMENT_GET_FAILURE";